import { render, staticRenderFns } from "./program.vue?vue&type=template&id=f1f952fc&scoped=true"
import script from "./program.vue?vue&type=script&lang=js"
export * from "./program.vue?vue&type=script&lang=js"
import style0 from "./program.vue?vue&type=style&index=0&id=f1f952fc&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f952fc",
  null
  
)

export default component.exports